import { isGrassfish } from './isGrassfish';

export const getAccountAvatarColor = () => {
  return isGrassfish()
    ? { background: '#F0F8FE', color: '#005766' }
    : { background: '#223041', color: '#84B4FF' };
};

export const getRandomUserAvatarColor = () => {
  // Background and color are used together, text is used when no background is set

  const signagePlayer = [
    { background: '#F5D77C', color: '#61501B', text: '#F5D77C' },
    { background: '#E79857', color: '#9D450F', text: '#E79857' },
    { background: '#ECB4C2', color: '#9B2638', text: '#ECB4C2' },
    { background: '#E6A1E8', color: '#97269B', text: '#E6A1E8' },
    { background: '#91B7F1', color: '#10498F', text: '#91B7F1' },
    { background: '#90E6AD', color: '#006421', text: '#90E6AD' },
  ];

  const grassfish = [
    { background: '#024551', color: '#F5D77C', text: '#927419' },
    { background: '#024551', color: '#E79857', text: '#A56938' },
    { background: '#024551', color: '#ECB4C2', text: '#C34867' },
    { background: '#024551', color: '#E6A1E8', text: '#AF4BB2' },
    { background: '#024551', color: '#74B3E3', text: '#4178A3' },
    { background: '#024551', color: '#90E6AD', text: '#2E834B' },
  ];

  const colors = isGrassfish() ? grassfish : signagePlayer;

  let r = Math.floor(Math.random() * colors.length);
  return colors[r];
};

const componentToHex = (c) => {
  var hex = c.toString(16);
  return hex.length == 1 ? '0' + hex : hex;
};

export const rgbToHex = (r, g, b) => {
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
};

export default {
  rgbToHex,
  getAccountAvatarColor,
  getRandomUserAvatarColor,
};
